import Vue from "vue";
import Router from "vue-router";
/* Layout */
import Layout from "@/layout";
import "/src/assets/iconfont/iconfont.css";
Vue.use(Router);

/* Router Modules */
// import componentsRouter from './modules/components'
// import chartsRouter from './modules/charts'
// import tableRouter from './modules/table'
// import nestedRouter from './modules/nested'
// import exampleRouter from './modules/example'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [{
        path: "/redirect",
        component: Layout,
        hidden: true,
        children: [{
            path: "/redirect/:path(.*)",
            component: () =>
                import ("@/views/redirect/index")
        }]
    },
    {
        path: "/login",
        component: () =>
            import ("@/views/login/index"),
        hidden: true
    },
    {
        path: "/openLogin",
        component: () =>
            import ("@/views/login/openLogin"),
        hidden: true
    },
    {
        path: "/apply",
        component: () =>
            import ("@/views/login/apply"),
        hidden: true
    },
    {
        path: "/Application",
        component: () =>
            import ("@/views/login/application"),
        hidden: true
    },
    {
        path: "/goHightSchool",
        component: () =>
            import ("@/views/login/goHightSchool"),
        hidden: true
    },
    {
        path: "/upSchool",
        component: () =>
            import ("@/views/login/upSchool"),
        hidden: true
    },
    {
        path: "/auth-redirect",
        component: () =>
            import ("@/views/login/auth-redirect"),
        hidden: true
    },
    {
        path: "/404",
        component: () =>
            import ("@/views/error-page/404"),
        hidden: true
    },
    {
        path: "/401",
        component: () =>
            import ("@/views/error-page/401"),
        hidden: true
    },

    {
        path: "/profile",
        component: Layout,
        redirect: "/profile/indexNew",
        hidden: true,
        children: [{
            path: "indexNew",
            component: () =>
                import ("@/views/profile/indexNew"),
            name: "Profile",
            meta: {
                title: "我的",
                icon: "user",
                noCache: true
            }
        }]
    }
];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [

    {
        path: "/",
        component: Layout,
        hidden: true,
        children: [{
            path: "/redirect/:path(.*)",
            component: () =>
                import ("@/views/redirect/index")
        }]
    },
    {
        path: "/dashboardT",
        component: Layout,
        redirect: "/dashboardT",
        label: '首页',
        paths: 'dashboardT/dashboardT',
        children: [{
            path: "dashboardT",
            component: () =>
                import ("@/views/dashboard/dashboardT"),
            name: "dashboardT",
            label: '首页',
            paths: 'dashboardT/dashboardT',
            meta: {
                title: "首页",
                icon: "dashboard",
                affix: true,
                icontg: "icon-dashboard",
                roles: ['dashboardT/dashboardT']
            }
        }]
    },
    {
        path: "/warrantyForm",
        component: Layout,
        label: '销售模块',
        paths: '/warrantyForm',
        meta:{
            keepAlive:true,
            title: "销售模块",
            icon: "dashboard",
            noCache: true,
            icontg: "dashboard",
            roles: ['/warrantyForm'],
        },
        children: [{
            path: "/warrantyForm",
            component: () =>
                import ("@/views/warrantyForm/index"),
            name: "warrantyForm",
            label: '呼吸机',
            paths: 'warrantyForm',
            meta: {
                title: "呼吸机",
                icon: "dashboard",
                noCache: true,
                icontg: "icon-dashboard",
                roles: ['warrantyForm']
            }},
            {
                path: "product",
                component: () =>
                    import ("@/views/warrantyForm/product"),
                name: "gather",
                label: '销售模块',
                paths: 'warrantyForm/product',
                meta: {
                    title: "销售模块",
                    icon: "el-icon-s-unfold",
                    noCache: true,
                    icontg: "el-icon-document",
                    roles: ['warrantyForm/product']
                }
            },
        ]
    },
    {
        path: "/driveScreen",
        component: Layout,
        label: '驾驶舱大屏',
        paths: 'driveScreen/driveScreen',
        children: [{
            path: "driveScreen",
            component: () =>
                import ("@/views/driveScreen/index"),
            name: "driveScreen",
            label: '驾驶舱大屏',
            paths: 'driveScreen/driveScreen', //screening/bookbuilding
            meta: {
                title: "驾驶舱大屏",
                icon: "el-icon-s-unfold",
                noCache: false,
                icontg: "el-icon-document",
                roles: ['driveScreen/driveScreen']
            }
        }]
    },
    {
        path: "/old",
        component: Layout,
        redirect: "/old",
        label: '驾驶舱大屏(旧)',
        paths: '/old',
        meta: {
            title: "驾驶舱大屏(旧)",
            icon: "dashboard",
            noCache: true,
            icontg: "icon-dashboard",
        },
        children: [{
            path: "old",
            component: () =>
                import ("@/views/driveScreen/indexOld"),
            name: "old",
            label: '驾驶舱大屏(旧)',
            paths: '/old', //screening/bookbuilding 
            meta: {
                title: "驾驶舱大屏(旧)",
                icon: "el-icon-s-unfold",
                noCache: true,
                icontg: "el-icon-document",
                roles: ['/indexOld']
            }
        }]
    },
    {
        path: "/screening",
        component: Layout,
        label: '视力筛查',
        paths: '/screening',
        meta: {
            keepAlive:true,
            title: "视力筛查",
            icon: "el-icon-s-custom",
            noCache: true,
            icontg: "el-icon-document",
            roles: ['/screening'],
        },
        children: [{
                path: "bookbuilding",
                component: () =>
                import ("@/views/children/bookbuilding"),
                name: "bookbuilding",
                label: '儿童建档',
                paths: 'screening/bookbuilding',
                meta: {
                    title: "儿童建档",
                    icon: "el-icon-s-unfold",
                    noCache: true,
                    icontg: "el-icon-document",
                    roles: ['screening/bookbuilding']
                }
            },
            {
                path: "gather",
                component: () =>
                    import ("@/views/screening/gather"),
                name: "gather",
                label: '采集数据',
                paths: 'screening/gather',
                meta: {
                    title: "采集数据",
                    icon: "el-icon-s-unfold",
                    noCache: true,
                    icontg: "el-icon-document",
                    roles: ['screening/gather']
                }
            },
            {
                path: "processing",
                component: () =>
                import ("@/views/screening/processing"),
                name: "processing",
                label: '数据查询',
                paths: 'screening/processing',
                meta: {
                    keepAlive:true,
                    title: "数据查询",
                    icon: "el-icon-s-unfold",
                    noCache: false,
                    icontg: "el-icon-document",
                    roles: ['screening/processing']
                }
            },
            // {
            //     path: "analyse",
            //     component: () =>
            //         import ("@/views/screening/analyse"),
            //     name: "analyse",
            //     label: '筛查数据分析',
            //     paths: 'screening/analyse',
            //     meta: {
            //         title: "筛查数据分析",
            //         icon: "el-icon-s-unfold",
            //         noCache: true,
            //         icontg: "el-icon-document",
            //         roles: ['screening/analyse']
            //     }
            // },

            // {
            //     path: "unusual",
            //     component: () =>
            //         import ("@/views/screening/unusual"),
            //     name: "unusual",
            //     meta: {
            //         title: "视力异常登记",
            //         icon: "el-icon-s-unfold",
            //         noCache: true,
            //         icontg: "el-icon-document",
            //         roles: ['admin/empty/empty']
            //     }
            // },
            // {
            //     path: "referral",
            //     component: () =>
            //         import ("@/views/screening/referral"),
            //     name: "referral",
            //     meta: {
            //         title: "转诊轨迹跟踪",
            //         icon: "el-icon-s-unfold",
            //         noCache: true,
            //         icontg: "el-icon-document",
            //         roles: ['admin/empty/empty']
            //     }
            // },
            // {
            //     path: "referralmanagement",
            //     component: () =>
            //         import ("@/views/screening/referralmanagement"),
            //     name: "referralmanagement",
            //     meta: {
            //         title: "转诊管理",
            //         icon: "el-icon-s-unfold",
            //         noCache: true,
            //         icontg: "el-icon-document",
            //         roles: ['admin/empty/empty']
            //     }
            // },
            // {
            //     path: "accepts",
            //     component: () =>
            //         import ("@/views/screening/accepts"),
            //     name: "accepts",
            //     meta: {
            //         title: "接诊管理",
            //         icon: "el-icon-s-unfold",
            //         noCache: true,
            //         icontg: "el-icon-document",
            //         roles: ['admin/empty/empty']
            //     }
            // },
            // {
            //     path: "plan",
            //     component: () =>
            //         import ("@/views/screening/plan"),
            //     name: "plan",
            //     meta: {
            //         title: "筛查计划管理",
            //         icon: "el-icon-s-unfold",
            //         noCache: true,
            //         icontg: "el-icon-document",
            //         roles: ['api/ScreeningPlan/list', 'admin/AdminUser/plan', 'admin/ScreeningPlan/delete', 'admin/ScreeningPlan/add', 'admin/ScreeningPlan/edit',
            //             'admin/ScreeningPlan/info'
            //         ]
            //     }
            // }, {
            //     path: "statistics",
            //     component: () =>
            //         import ("@/views/screening/statistics"),
            //     name: "statistics",
            //     meta: {
            //         title: "筛查计划统计",
            //         icon: "el-icon-s-unfold",
            //         noCache: true,
            //         icontg: "el-icon-document",
            //         roles: ['admin/empty/empty']
            //     }
            // },
        ]
    },


    {
        path: "/referral",
        component: Layout,
        label: '转诊管理',
        paths: '/referral',
        meta: {
            keepAlive:true,
            title: "转诊管理",
            icon: "el-icon-s-custom",
            noCache: true,
            icontg: "el-icon-document",
            roles: ['/referral'],
        },
        children: [{
                path: "referralmanagement",
                component: () =>
                    import ("@/views/screening/referralmanagement"),
                name: "referralmanagement",
                label: '转诊列表',
                paths: 'referral/referralmanagement',
                meta: {
                    keepAlive:true,
                    title: "转诊列表",
                    icon: "el-icon-s-unfold",
                    noCache: false,
                    icontg: "el-icon-document",
                    roles: ['referral/referralmanagement']
                }
            },
            {
                path: "accepts",
                component: () =>
                    import ("@/views/screening/accepts"),
                name: "accepts",
                paths: 'referral/accepts',
                label: '接诊列表',
                meta: {
                    keepAlive:true,
                    title: "接诊列表",
                    icon: "el-icon-s-unfold",
                    noCache: false,
                    icontg: "el-icon-document",
                    roles: ['referral/accepts']
                }
            },
            {
                path: "referral",
                component: () =>
                    import ("@/views/screening/referral"),
                name: "referral",
                paths: 'referral/referral',
                label: '转诊轨迹跟踪',
                meta: {
                    title: "转诊轨迹跟踪",
                    icon: "el-icon-s-unfold",
                    noCache: false,
                    icontg: "el-icon-document",
                    roles: ['referral/referral']
                }
            },

        ]
    },


    {
        path: "/follow",
        component: Layout,
        label: '随访管理',
        paths: '/follow',
        meta: {
            title: "随访管理",
            icon: "el-icon-s-custom",
            noCache: true,
            icontg: "el-icon-document",
            roles: ['/follow'],
        },
        children: [{
                path: "management",
                component: () =>
                    import ("@/views/follow/management"),
                name: "management",
                paths: 'follow/management',
                label: '随访列表',
                meta: {
                    title: "随访列表",
                    icon: "el-icon-s-unfold",
                    noCache: false,
                    icontg: "el-icon-document",
                    roles: ['follow/management']
                }
            },
            {
                path: "managementDetails",
                component: () =>
                    import ("@/views/follow/managementDetails"),
                name: "managementDetails",
                label: '随访详情',
                paths: 'follow/managementDetails',
                hidden: true,
                meta: {
                    title: "随访详情",
                    icon: "el-icon-s-tools",
                    noCache: false,
                    icontg: "el-icon-s-tools",
                    roles: ['follow/management']
                }
            },
            {
                path: "record",
                component: () =>
                    import ("@/views/follow/record"),
                name: "record",
                label: '随访记录',
                paths: 'follow/record',
                meta: {
                    title: "随访记录",
                    icon: "el-icon-s-unfold",
                    noCache: false,
                    icontg: "el-icon-document",
                    roles: ['follow/record']
                }
            },

            {
                path: "qstatistical",
                component: () =>
                    import ("@/views/follow/qstatistical"),
                name: "qstatistical",
                label: '问卷统计',
                paths: 'follow/qstatistical',
                meta: {
                    title: "问卷统计",
                    icon: "el-icon-s-unfold",
                    noCache: false,
                    icontg: "el-icon-document",
                    roles: ['follow/qstatistical']
                }
            },

            // {
            //     path: "inform",
            //     component: () =>
            //         import ("@/views/follow/inform"),
            //     name: "inform",
            //     meta: {
            //         title: "随访通知模板",
            //         icon: "el-icon-s-unfold",
            //         noCache: true,
            //         icontg: "el-icon-document",
            //         roles: ['admin/empty/empty']
            //     }
            // },
            // {
            //     path: "fstatistics",
            //     component: () =>
            //         import ("@/views/follow/fstatistics"),
            //     name: "fstatistics",
            //     meta: {
            //         title: "随访统计",
            //         icon: "el-icon-s-unfold",
            //         noCache: true,
            //         icontg: "el-icon-document",
            //         roles: ['admin/empty/empty']
            //     }
            // },
            // {
            //     path: "questionnaire",
            //     component: () =>
            //         import ("@/views/follow/questionnaire"),
            //     name: "questionnaire",
            //     hidden: true,
            //     meta: {
            //         title: "随访问卷模板",
            //         icon: "el-icon-s-unfold",
            //         noCache: true,
            //         icontg: "el-icon-document",
            //         roles: ['admin/FollowUpTpl/list', 'admin/FollowUpResult/add', 'admin/FollowUpTpl/edit', 'admin/FollowUpTpl/add', 'admin/FollowUpTpl/delete', 'admin/FollowUpTpl/info']
            //     }
            // },
            {
                path: "questionadmin",
                component: () =>
                    import ("@/views/follow/questionadmin"),
                name: "questionadmin",
                label: '随访问题管理',
                paths: 'follow/questionadmin',
                meta: {
                    title: "随访问题管理",
                    icon: "el-icon-s-unfold",
                    noCache: false,
                    icontg: "el-icon-document",
                    roles: ['follow/questionadmin']
                }
            },

        ]
    },




    {
        path: "/children",
        component: Layout,
        label: '儿童数据管理',
        paths: '/children',
        meta: { 
            keepAlive:true,
            title: "儿童数据管理",
            icon: "el-icon-s-custom",
            noCache: true,
            icontg: "el-icon-document",
            roles: ['/children']

        },
        children: [{
                path: "records",
                component: () =>
                import ("@/views/children/records"),
                name: "records",
                paths: 'children/records',
                label: '儿童档案管理',
                meta: {
                    keepAlive:true,
                    title: "儿童档案管理",
                    icon: "el-icon-s-unfold",
                    noCache: false,
                    icontg: "el-icon-document",
                    roles: ['children/records']
                }
            },
            {
                path: "childrenRecycle",
                component: () =>
                    import ("@/views/children/childrenRecycle"),
                name: "childrenRecycle",
                paths: 'children/childrenRecycle',
                label: '回收站',
                meta: {
                    title: "回收站",
                    icon: "el-icon-s-unfold",
                    noCache: true,
                    icontg: "el-icon-document",
                    roles: ['children/childrenRecycle']
                }
            },
            {
                path: "ageGrades",
                component: () =>
                    import ("@/views/children/ageGrades"),
                name: "ageGrades",
                paths: 'children/ageGrades',
                label: '儿童年龄阶段',
                meta: {
                    title: "儿童年龄阶段",
                    icon: "el-icon-s-unfold",
                    noCache: false,
                    icontg: "el-icon-document",
                    roles: ['children/ageGrades']
                }
            },
            {
                path: "setLable",
                component: () =>
                    import ("@/views/children/setLable"),
                name: "setLable",
                paths: 'children/setLable',
                label: '标签管理',
                meta: {
                    title: "标签管理",
                    icon: "el-icon-s-unfold",
                    noCache: false,
                    icontg: "el-icon-document",
                    roles: ['children/setLable']
                }
            },
            {
                path: "grade",
                component: () =>
                    import ("@/views/children/class"),
                name: "grade",
                label: '班级管理',
                paths: 'children/grade',
                meta: {
                    title: "班级管理",
                    icon: "el-icon-s-unfold",
                    noCache: false,
                    icontg: "el-icon-document",
                    roles: ['children/grade']

                }
            },
            // {
            //     path: "highSchool",
            //     component: () =>
            //         import ("@/views/children/highSchool"),
            //     name: "highSchool",
            //     label: '一键升学',
            //     paths: 'highSchool/grade',
            //     meta: {
            //         title: "一键升学",
            //         icon: "el-icon-s-unfold",
            //         noCache: false,
            //         icontg: "el-icon-document",
            //         roles: ['highSchool/grade']

            //     }
            // },
            {
                path: "newHighSchool",
                component: () =>
                    import ("@/views/children/newHighSchool"),
                name: "newHighSchool",
                label: '一键升学',
                paths: 'children/newHighSchool',
                meta: {
                    title: "一键升学",
                    icon: "el-icon-s-unfold",
                    noCache: false,
                    icontg: "el-icon-document",
                    roles: ['children/newHighSchool']
                }
            },
            {
                path: "highSchoolLog",
                component: () =>
                    import ("@/views/children/highSchoolLog"),
                name: "highSchoolLog",
                label: '历年升学记录',
                paths: 'children/highSchoolLog',
                meta: {
                    title: "历年升学记录",
                    icon: "el-icon-s-unfold",
                    noCache: false,
                    icontg: "el-icon-document",
                    roles: ['children/highSchoolLog']
                }
            },
            {
                path: "unbinding",
                component: () =>
                    import ("@/views/children/unbinding"),
                name: "Unbinding",
                label: '一键解绑',
                paths: 'children/unbinding',
                meta: {
                    title: "一键解绑",
                    icon: "el-icon-s-unfold",
                    noCache: false,
                    icontg: "el-icon-document",
                    roles: ['children/unbinding']

                }
            },
            // {
            //     path: "qrcodePrint",
            //     component: () =>
            //         import ("@/views/qrcodePrint/qrcodePrint"),
            //     name: "qrcodePrint",
            //     label: '批量打印',
            //     paths: 'children/qrcodePrint',
            //     meta: {
            //         title: "批量打印",
            //         icon: "excel",
            //         noCache: true,
            //         icontg: "el-icon-s-data"
            //     },
            //     roles: ['children/qrcodePrint']
            // }
        ]
    },
    
    {
        path: "/childrenTest",
        component: Layout,
        label: '儿童入园体检',
        paths: '/childrenTest',
        children: [{
            path: "/childrenTest",
            component: () =>
                import ("@/views/childrenTest/index"),
            name: "childrenTest",
            label: '儿童入园体检',
            paths: 'childrenTest',
            meta: {
                title: "儿童入园体检",
                icon: "dashboard",
                noCache: true,
                icontg: "icon-dashboard",
                roles: ['childrenTest']
            }
        }]
    },
    {
        path: "/childrenTestIndex",
        component: Layout,
        label: '儿童入园体检详情',
        paths: '/childrenTestIndex',
        hidden: true,
        children: [{
            path: "/childrenTestIndex",
            component: () =>
                import ("@/views/childrenTest/component/index"),
            name: "childrenTestIndex",
            label: '儿童入园体检详情',
            paths: 'childrenTestIndex',
            meta: {
                title: "儿童入园体检详情",
                icon: "dashboard",
                noCache: true,
                icontg: "icon-dashboard",
                roles: ['childrenTestIndex']
            }
        }]
    },
    {
        path: "/childCheck",
        component: Layout,
        label: '青少年体检',
        paths: '/childCheck',
        children: [{
            path: "/childCheck",
            component: () =>
                import ("@/views/childCheck/index"),
            name: "childCheck",
            label: '青少年体检',
            paths: 'childCheck',
            meta: {
                title: "青少年体检",
                icon: "dashboard",
                noCache: true,
                icontg: "icon-dashboard",
                roles: ['childCheck']
            }
        }]
    },
    {
        path: "/childCheckInfo",
        component: Layout,
        label: '青少年体检详情',
        paths: '/childCheckInfo',
        hidden: true,
        children: [{
            path: "/childCheckInfo",
            component: () =>
                import ("@/views/childCheck/info"),
            name: "childCheckInfo",
            label: '青少年体检详情',
            paths: 'childCheckInfo',
            meta: {
                title: "青少年体检详情",
                icon: "dashboard",
                noCache: true,
                icontg: "icon-dashboard",
                roles: ['childCheckInfo']
            }
        }]
    },
    {
        path: "/statement",
        component: Layout,
        label: '统计报表',
        paths: '/statement',
        meta: {
            title: "统计报表",
            icon: "excel",
            keepAlive: true,
            noCache: true,
            icontg: "el-icon-s-data",
            roles: ['/statement']
        },
        children: [{
                path: "samplingAnalysis",
                component: () =>
                    import ("@/views/statement/samplingAnalysis"),
                name: "samplingAnalysis",
                label: '抽样对比分析',
                paths: 'statement/samplingAnalysis',
                meta: {
                    title: "抽样对比分析",
                    icon: "el-icon-s-data",
                    noCache: false,
                    icontg: "el-icon-s-data",
                    roles: ['statement/samplingAnalysis']
                }
            }, {
                path: "analysisChart",
                component: () =>
                    import ("@/views/statement/analysisChart"),
                name: "analysisChart",
                label: '分析图表',
                paths: 'statement/analysisChart',
                meta: {
                    title: "分析图表",
                    icon: "el-icon-s-data",
                    noCache: false,
                    icontg: "el-icon-s-data",
                    roles: ['statement/analysisChart']
                }
            }, {
                path: "summarySheet",
                component: () =>
                    import ("@/views/statement/summarySheet"),
                name: "summarySheet",
                label: '工作指标统计',
                paths: 'statement/summarySheet',
                meta: {
                    title: "工作指标统计",
                    icon: "el-icon-s-data",
                    noCache: true,
                    icontg: "el-icon-s-data",
                    roles: ['statement/summarySheet']
                }
            }, {
                path: "eyeMessage",
                component: () =>
                    import ("@/views/statement/eyeMessage"),
                name: "eyeMessage",
                label: '眼保健及近视防控信息',
                paths: 'statement/eyeMessage',
                meta: {
                    title: "眼保健及近视防控信息",
                    icon: "el-icon-s-data",
                    noCache: true,
                    icontg: "el-icon-s-data",
                    roles: ['statement/eyeMessage']
                }
            },
            // {
            //   path: "summary",
            //   component: () =>
            //     import("@/views/statement/summary"),
            //   name: "Summary",
            //   label: '使用情况数据汇总',
            //   paths: 'statement/eyeMessage2',
            //   meta: {
            //     title: "系统使用情况数据汇总",
            //     icon: "el-icon-s-data",
            //     noCache: false,
            //     icontg: "el-icon-s-data",
            //     roles: ['statement/eyeMessage2']
            //   }
            // },
            {
                path: "summaryBen",
                component: () =>
                    import ("@/views/statement/summaryBen"),
                name: "summaryBen",
                label: '本机构使用情况数据汇总',
                paths: 'statement/summaryBen',
                meta: {
                    title: "本机构使用情况",
                    icon: "el-icon-s-data",
                    noCache: false,
                    icontg: "el-icon-s-data",
                    roles: ['statement/summaryBen']
                }
            },
            {
                path: "twoPlan",
                component: () =>
                    import ("@/views/statement/twoPlan"),
                name: "twoPlan",
                label: '双计划筛查儿童数据',
                paths: 'statement/twoPlan',
                meta: {
                    title: "双计划筛查儿童数据",
                    icon: "el-icon-s-data",
                    noCache: false,
                    icontg: "el-icon-s-data",
                    roles: ['statement/twoPlan']
                }
            },
            {
                path: "SummarySystem",
                component: () =>
                    import ("@/views/statement/SummarySystem"),
                name: "SummarySystem",
                label: '系统使用情况变化趋势图',
                paths: 'statement/SummarySystem',
                meta: {
                    title: "系统使用情况变化趋势图",
                    icon: "el-icon-s-data",
                    noCache: false,
                    icontg: "el-icon-s-data",
                    roles: ['statement/SummarySystem']
                }
            },{
                path: "teenStatistics",
                component: () =>
                    import ("@/views/statement/teenStatistics"),
                name: "teenStatistics",
                label: '青少年体检统计',
                paths: 'statement/teenStatistics',
                meta: {
                    title: "青少年体检统计",
                    icon: "el-icon-s-data",
                    noCache: false,
                    icontg: "el-icon-s-data",
                    roles: ['statement/teenStatistics']
                }
            },{
                path: "healthStatistics",
                component: () =>
                    import ("@/views/statement/healthStatistics"),
                name: "healthStatistics",
                label: '入园体检统计',
                paths: 'statement/healthStatistics',
                meta: {
                    title: "入园体检统计",
                    icon: "el-icon-s-data",
                    noCache: false,
                    icontg: "el-icon-s-data",
                    roles: ['statement/healthStatistics']
                }
            }
        ]
    },



    {
        path: "/childrenScreen",
        component: Layout,
        label: '儿童全息视图',
        paths: '/childrenScreen',
        meta: {
            title: "儿童全息视图",
            icon: "el-icon-map-location",
            noCache: true,
            icontg: "el-icon-document",
            roles: ['/childrenScreen']
        },
        children: [{
            path: "childrenScreen",
            component: () =>
                import ("@/views/childrenScreen/index"),
            name: "ChildrenScreen",
            label: '儿童全息视图',
            paths: 'childrenScreen/ChildrenScreen',
            meta: {
                title: "儿童全息视图",
                icon: "el-icon-map-location",
                noCache: true,
                icontg: "el-icon-document"
            },
            roles: ['childrenScreen/ChildrenScreen']
        }]
    },
    {
        path: "/question",
        component: Layout,
        label: '问卷管理',
        paths: '/question',
        meta: {
            title: "问卷管理",
            icon: "el-icon-s-data",
            noCache: true,
            icontg: "el-icon-s-data",
            roles: ['/question']
        },
        children: [{
            path: "question",
            component: () =>
                import ("@/views/question/index"),
            name: "ChildrenScreen",
            label: '问卷管理',
            paths: 'question/question',
            meta: {
                title: "问卷管理",
                icon: "el-icon-s-data",
                noCache: true,
                icontg: "el-icon-s-data"
            },
            roles: ['question/question']
        },{
            path: "questionInfo",
            component: () =>
                import ("@/views/question/info"),
            name: "questionInfo",
            label: '问卷详情',
            paths: 'question/questionInfo',
            hidden: true,
            meta: {
                title: "问卷详情",
                icon: "el-icon-s-data",
                noCache: false,
                icontg: "el-icon-s-data"
            },
            roles: ['question/question']
        },{
            path: "questionStat",
            component: () =>
                import ("@/views/question/stat"),
            name: "questionStat",
            label: '答案统计',
            paths: 'question/questionStat',
            hidden: true,
            meta: {
                title: "答案统计",
                icon: "el-icon-s-data",
                noCache: false,
                icontg: "el-icon-s-data"
            },
            roles: ['question/question']
        },{
            path: "answer",
            component: () =>
                import ("@/views/question/answer"),
            name: "answer",
            label: '答案管理',
            paths: 'question/answer',
            meta: {
                title: "答案管理",
                icon: "el-icon-s-data",
                noCache: true,
                icontg: "el-icon-s-data"
            },
            roles: ['question/question']
        },{
            path: "infoAnswer",
            component: () =>
                import ("@/views/question/infoAnswer"),
            name: "infoAnswer",
            label: '答案详情',
            paths: 'question/infoAnswer',
            hidden: true,
            meta: {
                title: "答案详情",
                icon: "el-icon-s-data",
                noCache: true,
                icontg: "el-icon-s-data"
            },
            roles: ['question/question']
        }]
    },
    
    {
        path: "/newInsapply",
        component: Layout,
        label: '机构审核',
        paths: '/newInsapply',
        meta: {
            title: "机构审核",
            icon: "el-icon-s-custom",
            noCache: true,
            icontg: "el-icon-s-custom",
            roles: ['/newInsapply']
        },
        children: [{
            path: "insApply",
            component: () =>
                import ("@/views/system/insApply"),
            name: "systemInsApply",
            label: '机构审核',
            paths: 'newInsapply/insApply',
            meta: {
                title: "机构审核",
                icon: "el-icon-s-custom",
                noCache: false,
                icontg: "el-icon-s-custom",
                roles: ['newInsapply/insApply']
            }
        },{
            path: "insApplyInfo",
            component: () =>
                import ("@/views/system/insApplyInfo"),
            name: "systemInsApplyInfo",
            label: '申请详情',
            paths: 'newInsapply/insApplyInfo',
            hidden: true,
            meta: {
                title: "申请详情",
                icon: "el-icon-s-custom",
                noCache: false,
                icontg: "el-icon-s-custom",
                roles: ['newInsapply/insApply']
            }
        },]
    },
    // {
    //     path: "/printMessage",
    //     component: Layout,
    //     label: '打印信息',
    //     hidden:false,
    //     paths: '/printMessage',
    //     meta: {
    //         title: "打印信息",
    //         icon: "excel",
    //         noCache: true,
    //         icontg: "el-icon-s-data",
    //         roles: ['/printMessage']
    //     },
    //     children: [{
    //         path: "qrcodePrint",
    //         component: () =>
    //             import ("@/views/qrcodePrint/qrcodePrint"),
    //         name: "qrcodePrint",
    //         label: '打印二维码',
    //         paths: 'printMessage/qrcodePrint',
    //         meta: {
    //             title: "打印二维码",
    //             icon: "excel",
    //             noCache: true,
    //             icontg: "el-icon-s-data"
    //         },
    //         roles: ['printMessage/qrcodePrint']
    //     }]
    // },

    {
        path: "/user",
        component: Layout,
        // alwaysShow: true,
        label: '系统用户',
        paths: '/user',
        meta: {
            title: "系统用户",
            icon: "xtgl",
            noCache: true,
            icontg: "el-icon-receiving",
            roles: ['/user']
        },
        children: [{
                path: "users",
                component: () =>
                    import ("@/views/system/index"),
                name: "systemIndex",
                label: '账号管理',
                paths: 'user/users',
                meta: {
                    title: "账号管理",
                    icon: "el-icon-s-custom",
                    noCache: false,
                    icontg: "el-icon-s-custom",
                    roles: ['user/users']
                }
            },
            {
                path: "adminlog",
                component: () =>
                    import ("@/views/system/adminlog"),
                name: "adminLog",
                label: '开发管理日志',
                paths: 'user/adminLog',
                meta: {
                    title: "开发管理日志",
                    icon: "el-icon-document",
                    noCache: true,
                    icontg: "el-icon-document",
                    roles: ['user/adminLog']
                }
            },
            {
                path: "userAdminlog",
                component: () =>
                    import ("@/views/system/userAdminlog"),
                name: "userAdminlog",
                label: '用户管理日志',
                paths: 'user/adminLog',
                meta: {
                    title: "用户管理日志",
                    icon: "el-icon-document",
                    noCache: true,
                    icontg: "el-icon-document",
                    roles: ['user/adminLog']
                }
            },
            {
                path: "operationLog",
                component: () =>
                    import ("@/views/operationLog/index"),
                name: "operationLog",
                label: '管理日志',
                paths: 'user/operationLog',
                meta: {
                    title: "管理日志",
                    icon: "el-icon-document",
                    noCache: true,
                    icontg: "el-icon-document",
                    roles: ['user/operationLog']
                }
            },
            {
                path: "role",
                component: () =>
                    import ("@/views/system/role"),
                name: "RolePermission",
                label: '角色管理',
                paths: 'role/role',
                meta: {
                    title: "角色管理",
                    icon: "el-icon-user",
                    icontg: "el-icon-user",
                    roles: ['role/role']
                }
            }
        ]
    },

    {
        path: "/admin",
        component: Layout,
        // alwaysShow: true,
        label: '系统管理',
        paths: '/admin',
        meta: {
            title: "系统管理",
            icon: "xtgl",
            noCache: true,
            icontg: "el-icon-receiving",
            roles: ['/admin']
        },
        // , 'admin/Api/list', 'admin/Api/add',
        // 'admin/Api/unlogin', 'admin/Curd/getConfig', 'admin/Curd/createCurd',
        // 'admin/AdminSysconfig/list', 'admin/AdminSysconfig/getConfig', 'admin/AdminMenu/list'
        children: [

            {
                path: "api",
                component: () =>
                    import ("@/views/setting/api"),
                name: "ApiSetting",
                label: '接口设置',
                paths: 'admin/api',
                meta: {
                    title: "接口设置",
                    icon: "el-icon-s-tools",
                    noCache: true,
                    icontg: "el-icon-s-tools",
                    roles: ['admin/api']
                }
            },

            {
                path: "config",
                component: () =>
                    import ("@/views/sysconfig/index"),
                name: "SysConfig",
                label: '系统配置',
                paths: 'admin/config',
                meta: {
                    title: "系统配置",
                    icon: "el-icon-s-tools",
                    noCache: true,
                    icontg: "el-icon-s-tools",
                    roles: ['admin/config']
                }
            },
            {
                path: "menu",
                component: () =>
                    import ("@/views/system/menu"),
                name: "MenuPermission",
                // hidden: true,
                label: '菜单管理',
                paths: 'admin/menu',
                meta: {
                    title: "菜单管理",
                    icon: "el-icon-document",
                    noCache: true,
                    icontg: "el-icon-document",
                    roles: ['admin/menu']
                }
            },

            {
                path: "pageManagement",
                component: () =>
                    import ("@/views/system/pageManagement"),
                name: "pageManagement",
                // hidden: true,
                label: '页面管理',
                paths: 'admin/pageManagement',
                meta: {
                    title: "页面管理",
                    icon: "el-icon-document",
                    noCache: true,
                    icontg: "el-icon-document",
                    roles: ['admin/pageManagement']
                }
            },
            {
                path: "clearcache",
                component: () =>
                    import ("@/views/system/clearcache"),
                name: "clearcache",
                label: '清除缓存',
                paths: 'admin/clearcache',
                meta: {
                    title: "清除缓存",
                    icon: "el-icon-document",
                    noCache: true,
                    icontg: "el-icon-document",
                    roles: ['admin/clearcache']
                }
            },
            // {
            //     path: "category",
            //     component: () =>
            //         import ("@/views/system/category"),
            //     name: "SysCategory",
            //     hidden: true,
            //     meta: {
            //         title: "分类管理",
            //         icon: "el-icon-menu",
            //         noCache: true,
            //         icontg: "el-icon-menu"
            //     }
            // },
            {
                path: "setting",
                component: () =>
                    import ("@/views/sysconfig/setting"),
                name: "配置管理",
                label: '配置管理',
                // hidden:true,
                paths: 'admin/setting',
                meta: {
                    title: "配置管理",
                    icon: "el-icon-setting",
                    noCache: true,
                    icontg: "el-icon-setting",
                    roles: ['admin/setting']
                }
            },
            {
                path: "curd",
                component: () =>
                    import ("@/views/system/curd"),
                name: "CreateCurd",
                label: 'CURD生成',
                paths: 'admin/curd',
                meta: {
                    title: "CURD生成",
                    icon: "el-icon-setting",
                    // noCache: true,
                    icontg: "el-icon-setting",
                    roles: ['admin/curd']
                }
            }
        ]
    },

    {
        path: "/adminSetUp",
        component: Layout,
        label: '系统设置',
        paths: '/adminSetUp',
        meta: {
            keepAlive:true,
            title: "系统设置",
            icon: "xtgl",
            noCache: true,
            icontg: "el-icon-receiving",
            roles: ['/adminSetUp']
        },
        children: [{
                path: "CheckStandard",
                component: () =>
                    import ("@/views/checkStandard/index"),
                name: "CheckStandard",
                label: '检查标准',
                paths: 'adminSetUp/CheckStandard',
                meta: {
                    title: "检查标准",
                    icon: "el-icon-s-tools",
                    noCache: false,
                    icontg: "el-icon-s-tools",
                    roles: ['adminSetUp/CheckStandard']
                }
            },
            {
                path: "DiseaseManagement",
                component: () =>
                    import ("@/views/diseaseManagement/index"),
                name: "DiseaseManagement",
                label: '病症管理',
                paths: 'adminSetUp/DiseaseManagement',
                meta: {
                    title: "病症管理",
                    icon: "el-icon-s-tools",
                    noCache: false,
                    icontg: "el-icon-s-tools",
                    roles: ['adminSetUp/DiseaseManagement']
                }
            },
            {
                path: "ProjectManagement",
                component: () =>
                    import ("@/views/projectManagement/index"),
                name: "ProjectManagement",
                label: '项目管理',
                paths: 'adminSetUp/ProjectManagement',
                meta: {
                    title: "项目管理",
                    icon: "el-icon-s-tools",
                    noCache: false,
                    icontg: "el-icon-s-tools",
                    roles: ['adminSetUp/ProjectManagement']
                }
            },
            {
                path: "RegionManagement",
                component: () =>
                    import ("@/views/regionManagement/index"),
                name: "RegionManagement",
                label: '地区管理',
                paths: 'adminSetUp/RegionManagement',
                meta: {
                    title: "地区管理",
                    icon: "el-icon-s-tools",
                    noCache: false,
                    icontg: "el-icon-s-tools",
                    roles: ['adminSetUp/RegionManagement']
                }
            },
            {
                path: "regionNum",
                component: () =>
                    import ("@/views/regionManagement/regionNum"),
                name: "regionNum",
                label: '地区计划人数',
                paths: 'adminSetUp/regionNum',
                hidden: true,
                meta: {
                    title: "地区计划人数",
                    icon: "el-icon-s-tools",
                    noCache: false,
                    icontg: "el-icon-s-tools",
                    roles: ['adminSetUp/plan']
                }
            },
            {
                path: "InstitutionManagement",
                component: () =>
                import ("@/views/institutionManagement/institution"),
                name: "InstitutionManagement",
                label: '机构管理',
                paths: 'adminSetUp/InstitutionManagement',
                meta: {
                    keepAlive:true,
                    title: "机构管理",
                    icon: "el-icon-s-tools",
                    noCache: false,
                    icontg: "el-icon-s-tools",
                    roles: ['adminSetUp/InstitutionManagement']
                }
            },
            {
                path: "information",
                component: () =>
                import ("@/views/institutionManagement/information"),
                name: "information",
                label: '预约信息',
                paths: 'adminSetUp/information',
                meta: {
                    title: "预约信息",
                    icon: "el-icon-s-tools",
                    noCache: true,
                    icontg: "el-icon-s-tools",
                    roles: ['adminSetUp/information']
                }
            },
            {
                path: "InstitutionInfor",
                component: () =>
                    import ("@/views/institutionManagement/infor"),
                name: "InstitutionInfor",
                label: '机构详情',
                paths: 'adminSetUp/InstitutionInfor',
                hidden: true,
                meta: {
                    title: "机构详情",
                    icon: "el-icon-s-tools",
                    noCache: false,
                    icontg: "el-icon-s-tools",
                    roles: ['adminSetUp/InstitutionManagement']

                }
            },
            // {
            //     path: "shua",
            //     component: () =>
            //         import ("@/views/institutionManagement/shua"),
            //     name: "shua",
            //     label: '刷新',
            //     // paths: 'adminSetUp/information',
            //     meta: {
            //         title: "刷新",
            //         icon: "el-icon-s-tools",
            //         noCache: true,
            //         hidden: true,
            //         icontg: "el-icon-s-tools",
            //         // roles: ['adminSetUp/information2']
            //     }
            // },
            {
                path: "DeviceManagement",
                component: () =>
                import ("@/views/deviceManagement/index"),
                name: "DeviceManagement",
                label: '设备管理',
                paths: 'adminSetUp/DeviceManagement',
                meta: {
                    title: "设备管理",
                    icon: "el-icon-s-tools",
                    noCache: false,
                    icontg: "el-icon-s-tools",
                    roles: ['adminSetUp/DeviceManagement']
                }
            },
            {
                path: "Templatemanagement",
                component: () =>
                    import ("@/views/templatemanagement/index"),
                name: "Templatemanagement",
                label: '模板管理',
                paths: 'adminSetUp/Templatemanagement',
                meta: {
                    title: "模板管理",
                    icon: "el-icon-s-tools",
                    noCache: false,
                    icontg: "el-icon-s-tools",
                    roles: ['adminSetUp/Templatemanagement']
                }
            },
            {
                path: "plan",
                component: () =>
                    import ("@/views/screening/plan"),
                name: "plan",
                paths: 'adminSetUp/plan',
                label: '筛查计划管理',
                meta: {
                    title: "筛查计划管理",
                    icon: "el-icon-s-unfold",
                    noCache: false,
                    icontg: "el-icon-document",
                    roles: ['adminSetUp/plan']
                }
            },

        ]
    },

    {
        path: "/wechat",
        component: Layout,
        alwaysShow: true,
        label: '微信管理',
        paths: '/wechat',
        meta: {
            title: "微信管理",
            icon: "el-icon-s-help",
            noCache: true,
            icontg: "el-icon-document",
            roles: ['/wechat']
        },
        children: [{
                path: "user",
                component: () =>
                    import ("@/views/weChat/user"),
                name: "wechatUser",
                label: '用户管理',
                paths: 'wechat/user',
                meta: {
                    title: "用户管理",
                    icon: "el-icon-user",
                    noCache: true,
                    icontg: "el-icon-user",
                    roles: ['wechat/user']

                }
            },
            {
                path: "autoResponse",
                component: () =>
                    import ("@/views/weChat/autoResponse"),
                name: "wechatAutoResponse",
                label: '自动回复',
                paths: 'wechat/autoResponse',
                meta: {
                    title: "自动回复",
                    icon: "el-icon-chat-dot-square",
                    noCache: true,
                    icontg: "el-icon-document",
                    roles: ['wechat/autoResponse']
                }
            },
            {
                path: "wxkf",
                is_wb: true,
                name: "wechatCustomerService",
                label: '微信客服',
                paths: 'wechat/wxkf',
                meta: {
                    title: "微信客服",
                    icon: "el-icon-service",
                    noCache: true,
                    icontg: "el-icon-service",
                    roles: ['wechat/wxkf']
                }
            },
            {
                path: "customerService",
                component: () =>
                    import ("@/views/weChat/customerService"),
                name: "wechatCustomerService",
                label: '客服管理',
                paths: 'wechat/customerService',
                meta: {
                    title: "客服管理",
                    icon: "el-icon-service",
                    noCache: true,
                    icontg: "el-icon-service",
                    roles: ['wechat/customerService']
                }
            },
            {
                path: "chatLogs",
                component: () =>
                    import ("@/views/weChat/chatLogs"),
                name: "wechatChatLogs",
                label: '客服聊天记录',
                paths: 'wechat/chatLogs',
                meta: {
                    title: "客服聊天记录",
                    icon: "el-icon-chat-line-square",
                    noCache: true,
                    icontg: "el-icon-chat-line-square",
                    roles: ['wechat/chatLogs']
                }
            },
            {
                path: "intellect",
                component: () =>
                    import ("@/views/weChat/intellect"),
                name: "wechatIntellect",
                label: '智能聊天记录',
                paths: 'wechat/intellect',
                meta: {
                    title: "智能聊天记录",
                    icon: "el-icon-chat-line-square",
                    noCache: true,
                    icontg: "el-icon-chat-line-square",
                    roles: ['wechat/intellect']
                }
            },
            {
                path: "material",
                component: () =>
                    import ("@/views/weChat/material"),
                name: "wechatMaterial",
                label: '素材库管理',
                paths: 'wechat/material',
                meta: {
                    title: "素材库管理",
                    icon: "el-icon-picture",
                    noCache: true,
                    icontg: "el-icon-picture",
                    roles: ['wechat/material']
                }
            },
            {
                path: "mass",
                component: () =>
                    import ("@/views/weChat/mass"),
                name: "wechatMass",
                label: '群发管理',
                paths: 'wechat/mass',
                meta: {
                    title: "群发管理",
                    icon: "el-icon-position",
                    noCache: true,
                    icontg: "el-icon-position",
                    roles: ['wechat/mass']
                }
            },
            {
                path: "customMenu",
                component: () =>
                    import ("@/views/weChat/customMenu"),
                name: "wechatCustomMenu",
                label: '自定义菜单',
                paths: 'wechat/customMenu',
                meta: {
                    title: "自定义菜单",
                    icon: "el-icon-menu",
                    noCache: true,
                    icontg: "el-icon-menu",
                    roles: ['wechat/customMenu']
                }
            },
            {
                path: "templateInfo",
                component: () =>
                    import ("@/views/weChat/templateInfo"),
                name: "wechatTemplateInfo",
                label: '模板详情',
                paths: 'wechat/templateInfo',
                hidden: true,
                meta: {
                    title: "模板详情",
                    icon: "el-icon-s-order",
                    noCache: true,
                    icontg: "el-icon-document",
                    roles: ['wechat/templateInfo']
                }
            },
            {
                path: "subscription",
                component: () =>
                    import ("@/views/weChat/subscription"),
                name: "wechatSubscription",
                label: '订阅管理',
                paths: 'wechat/subscription',
                meta: {
                    title: "订阅管理",
                    icon: "el-icon-open",
                    noCache: true,
                    icontg: "el-icon-document",
                    roles: ['wechat/subscription']
                }
            },
            {
                path: "setCategory",
                component: () =>
                    import ("@/views/weChat/setCategory"),
                name: "wechatSetCategory",
                label: '类目管理',
                paths: 'wechat/setCategory',
                hidden: true,
                meta: {
                    title: "类目管理",
                    icon: "el-icon-open",
                    noCache: true,
                    icontg: "el-icon-document",
                    roles: ['wechat/setCategory']
                }
            },
            {
                path: "template",
                component: () =>
                    import ("@/views/weChat/template"),
                name: "wechatTemplate",
                label: '模板管理',
                paths: 'wechat/template',
                meta: {
                    title: "模板管理",
                    icon: "el-icon-s-order",
                    noCache: true,
                    icontg: "el-icon-document",
                    roles: ['wechat/template']
                }
            },
            {
                path: "templateLibrary",
                component: () =>
                    import ("@/views/weChat/templateLibrary"),
                name: "wechatTemplateLibrary",
                label: '模板库',
                paths: 'wechat/templateLibrary',
                hidden: true,
                meta: {
                    title: "模板库",
                    icon: "el-icon-s-order",
                    noCache: true,
                    icontg: "el-icon-document",
                    roles: ['wechat/templateLibrary']
                }
            },
        ]
    },






    {
        path: "/member",
        component: Layout,
        label: '家长端管理',
        paths: '/member',
        meta: {
            title: "家长端管理",
            icon: "el-icon-s-custom",
            noCache: true,
            icontg: "el-icon-document",
            roles: ['/member']
        },
        children: [{
                path: "index",
                component: () =>
                    import ("@/views/member/index"),
                name: "memberList",
                paths: 'member/index',
                label: '家长列表',
                meta: {
                    title: "家长列表",
                    icon: "el-icon-s-unfold",
                    noCache: true,
                    icontg: "el-icon-document",
                    roles: ['member/index']
                }
            },
            {
                path: "log",
                component: () =>
                    import ("@/views/member/log"),
                name: "memberLog",
                label: '家长日志',
                paths: 'member/log',
                meta: {
                    title: "家长日志",
                    icon: "el-icon-document",
                    noCache: true,
                    icontg: "el-icon-document",
                    roles: ['member/log']
                }
            },
        ]
    },
    {
        path: "/meeting",
        component: Layout,
        label: '指导中心',
        paths: '/meeting',
        meta: {
            title: "指导中心",
            icon: "el-icon-s-custom",
            noCache: true,
            icontg: "el-icon-document",
            roles: ['/meeting'],
        },
        children: [{
                path: "meetingView",
                component: () =>
                    import ("@/views/meetingView/index"),
                name: "meetingView",
                label: '指导中心',
                paths: 'meeting/meetingView',
                meta: {
                    title: "指导中心",
                    icon: "dashboard",
                    noCache: false,
                    icontg: "icon-dashboard",
                    roles: ['meeting/meetingView']
                }
            }, {
                path: "meeting",
                component: () =>
                    import ("@/views/meeting/index"),
                name: "meeting",
                label: '指导中心编辑',
                paths: 'meeting/meeting',
                meta: {
                    title: "指导中心编辑",
                    icon: "dashboard",
                    noCache: false,
                    icontg: "icon-dashboard",
                    roles: ['meeting/meeting']
                }
            },
            {
                path: "classify",
                component: () =>
                    import ("@/views/meeting/classify"),
                name: "classify",
                label: '指导中心类别',
                paths: 'meeting/classify',
                meta: {
                    title: "指导中心类别",
                    icon: "dashboard",
                    noCache: false,
                    icontg: "icon-dashboard",
                    roles: ['meeting/classify']
                }
            },
            {
                path: "statistics",
                component: () =>
                    import ("@/views/meeting/statistics"),
                name: "Statistics",
                label: '观看情况统计',
                paths: 'meeting/statistics',
                meta: {
                    title: "观看情况统计",
                    icon: "dashboard",
                    noCache: false,
                    icontg: "icon-dashboard",
                    roles: ['meeting/statistics']
                }
            }
        ]
    },
    {
        path: "/newApply",
        component: Layout,
        label: '机构申请审核',
        paths: '/newApply',
        meta: {
            title: "机构申请审核",
            icon: "el-icon-s-custom",
            noCache: true,
            icontg: "el-icon-document",
            roles: ['/newApply'],
        },
        children: [{
            path: "apply",
            component: () =>
                import ("@/views/system/apply"),
            name: "systemApply",
            label: '申请审核管理',
            paths: 'newApply/apply',
            meta: {
                title: "申请审核管理",
                icon: "el-icon-s-custom",
                noCache: false,
                icontg: "el-icon-s-custom",
                roles: ['newApply/apply']
            }
        }, {
            path: "applyInfo",
            component: () =>
                import ("@/views/system/applyInfo"),
            name: "systemApplyInfo",
            label: '机构申请详情',
            paths: 'newApply/applyInfo',
            hidden: true,
            meta: {
                title: "机构申请详情",
                icon: "el-icon-s-custom",
                noCache: false,
                icontg: "el-icon-s-custom",
                roles: ['newApply/apply']
            }
        }, ]
    },

    {
        path: "/editPassword",
        component: Layout,
        label: '修改密码',
        paths: '/editPassword',
        meta: {
            title: "修改密码",
            icon: "el-icon-s-custom",
            noCache: true,
            icontg: "el-icon-document",
            roles: ['/editPassword'],
        },
        children: [{
            path: "editPass",
            component: () =>
                import ("@/views/system/editPassword"),
            name: "systemApply",
            label: '修改密码',
            paths: 'editPassword/editPass',
            meta: {
                title: "修改密码",
                icon: "el-icon-s-custom",
                noCache: false,
                icontg: "el-icon-s-custom",
                roles: ['editPassword/editPass']
            }
        }]
    },
    // {
    //     path: "/region",
    //     component: Layout,
    //     hidden: true,
    //     meta: {
    //         title: "地区管理",
    //         icon: "el-icon-map-location",
    //         noCache: true,
    //         icontg: "el-icon-document",
    //     },
    //     children: [{
    //         path: "index",
    //         component: () =>
    //             import ("@/views/region/index"),
    //         name: "regionList",
    //         meta: {
    //             title: "地区管理",
    //             icon: "el-icon-map-location",
    //             noCache: true,
    //             icontg: "el-icon-document"
    //         }
    //     }]
    // },
    // {
    //     path: "/operation",
    //     component: Layout,
    //     hidden: true,
    //     meta: {
    //         title: "运营活动",
    //         icon: "wuliao",
    //         noCache: true,
    //         icontg: "el-icon-document"
    //     },
    //     children: [{
    //         path: "index",
    //         component: () =>
    //             import ("@/views/operation/index"),
    //         name: "广告管理",
    //         meta: {
    //             title: "广告管理",
    //             icon: "el-icon-bell",
    //             noCache: true,
    //             icontg: "el-icon-document"
    //         }
    //     }]
    // },

    ///////////////////////////////////////////////////////////////////////////////////
    // {
    //     path: "/content",
    //     component: Layout,
    //     hidden: true,
    //     meta: {
    //         title: "内容管理",
    //         icon: "el-icon-document-copy",
    //         // noCache: true,
    //         icontg: "el-icon-document"
    //     },
    //     children: [{
    //             path: "notice",
    //             component: () =>
    //                 import ("@/views/content/notice"),
    //             name: "noticeContent",
    //             meta: {
    //                 title: "公告管理",
    //                 icon: "wuliao",
    //                 //   noCache: true,
    //                 icontg: "el-icon-document"
    //             }
    //         },
    //         {
    //             path: "video",
    //             component: () =>
    //                 import ("@/views/content/video"),
    //             name: "videoContent",
    //             meta: {
    //                 title: "课程管理",
    //                 icon: "el-icon-s-marketing",
    //                 noCache: true,
    //                 icontg: "el-icon-document"
    //             }
    //         },
    //         {
    //             path: "info",
    //             component: () =>
    //                 import ("@/views/content/info"),
    //             name: "infoContent",
    //             meta: {
    //                 title: "资料管理",
    //                 icon: "el-icon-document",
    //                 noCache: true,
    //                 icontg: "el-icon-document"
    //             }
    //         }
    //     ]
    // },

    ///////////////////////////////////////////////////////////////////////////////////

    // {
    //     path: "/extend",
    //     component: Layout,
    //     meta: {
    //         title: "扩展管理",
    //         icon: "wuliao",
    //         noCache: true,
    //         icontg: "el-icon-document",

    //     },
    //     hidden: true,
    //     children: [{
    //             path: "model",
    //             component: () =>
    //                 import ("@/views/system/model"),
    //             name: "SysModel",
    //             meta: {
    //                 title: "模型管理",
    //                 icon: "el-icon-setting",
    //                 noCache: true,
    //                 icontg: "el-icon-setting"
    //             }
    //         },
    //         {
    //             path: "field",
    //             component: () =>
    //                 import ("@/views/system/field"),
    //             name: "SysField",
    //             meta: {
    //                 title: "字段管理",
    //                 icon: "wuliao",
    //                 noCache: true,
    //                 icontg: "el-icon-document"
    //             }
    //         }
    //     ]
    // },
    // {
    //     path: "/setting",
    //     component: Layout,
    //     name: "setting",
    //     hidden: true,
    //     meta: {
    //         title: "设置管理",
    //         icon: "el-icon-setting",
    //         noCache: true,
    //         icontg: "el-icon-setting",
    //     },
    //     children: [{
    //             path: "api",
    //             component: () =>
    //                 import ("@/views/setting/api"),
    //             name: "ApiSetting",
    //             hidden: true,
    //             meta: {
    //                 title: "接口设置",
    //                 icon: "el-icon-s-tools",
    //                 noCache: true,
    //                 icontg: "el-icon-s-tools"
    //             }
    //         },
    //         {
    //             path: "front",
    //             component: () =>
    //                 import ("@/views/setting/front"),
    //             name: "FrontSetting",
    //             meta: {
    //                 title: "前台设置",
    //                 icon: "el-icon-s-tools",
    //                 noCache: true,
    //                 icontg: "el-icon-s-tools",
    //             }
    //         },
    //         {
    //             path: "backend",
    //             component: () =>
    //                 import ("@/views/setting/backend"),
    //             name: "BackendSetting",
    //             meta: {
    //                 // roles: [
    //                 // 'admin/AdminSetting/cacheInfo',
    //                 // 'admin/AdminSetting/tokenInfo',
    //                 // 'admin/AdminSetting/captchaInfo',
    //                 // 'admin/AdminSetting/logInfo',
    //                 // 'admin/AdminSetting/apiInfo'
    //                 // ],
    //                 title: "后台设置",
    //                 icon: "el-icon-s-tools",
    //                 noCache: true,
    //                 icontg: "el-icon-s-tools",
    //             }
    //         },
    //         {
    //             path: "wechat",
    //             component: () =>
    //                 import ("@/views/setting/wechat"),
    //             name: "WechatSetting",
    //             meta: {
    //                 title: "微信设置",
    //                 icon: "el-icon-s-tools",
    //                 noCache: true,
    //                 icontg: "el-icon-s-tools"
    //             }
    //         }
    //     ]
    // },
    {
        path: "*",
        redirect: "/404",
        label: '404',
        hidden: true,
        noCache: true,
        disabled: true,
    }
];

const createRouter = () =>
    new Router({
        // mode: 'history', // require service support
        scrollBehavior: () => ({
            y: 0
        }),
        routes: constantRoutes
    });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher; // reset router
}

export default router;